import { useEffect, useRef } from 'react'
import Drawer from '@mui/material/Drawer'
import Stack from '@mui/material/Stack'
import Box from '@mui/material/Box'
import { ReactComponent as IconClose } from '../icons/Close.svg'

const BottomDrawer = ({
  title,
  children,
  open,
  onClose,
  hideClose,
}) => {
  const drawerRef = useRef()

  useEffect(() => {
    if (open && drawerRef.current) {
      drawerRef.current.scrollTop = 0
    }
  }, [open])

  return (
    <Drawer
      ref={drawerRef}
      anchor="bottom"
      PaperProps={{
        sx: {
          borderTopLeftRadius: '20px',
          borderTopRightRadius: '20px',
        },
      }}
      open={open}
      onClose={onClose}
    >
      <Stack
        role="presentation"
        px={{
          xs: 2,
          md: 4,
        }}
        sx={{
          position: 'sticky',
          top: 0,
          zIndex: 1,
          backgroundColor: 'white',
        }}
      >
        <Stack
          py={{
            xs: 2,
            md: 4,
          }}
          display="grid"
          gap={2}
          gridAutoFlow="column"
          justifyContent="space-between"
          alignItems="flex-start"
        >
          {title}
          {hideClose ? <div /> : (
            <Box
              onClick={onClose}
              aria-label="close"
              sx={{
                zIndex: 1,
                cursor: 'pointer',
                '& svg': {
                  width: 22,
                  height: 22,
                },
              }}
            >
              <IconClose />
            </Box>
          )}
        </Stack>
        <Stack
          display="grid"
          sx={{
            overflowY: 'auto',
          }}
          pb={6}
        >
          {children}
        </Stack>
      </Stack>
    </Drawer>
  )
}

export default BottomDrawer
